module.exports = __webpack_public_path__ + "assets/img/bbef8bb0737ada5d5a199c9422aadb9e.png";